import React from 'react'
import Tooltip from '@bufferapp/ui/Tooltip'

import { Wrapper, IconWrapper } from './Label.styles'
import { LABELS } from '~/app/constants'

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'type' implicitly has an 'any' typ... Remove this comment to see the full error message
const Label = ({ type }) => {
  const label = LABELS.find((el) => el.id === type)

  if (!label) return null

  const Icon = label ? label.icon : null

  return (
    <Tooltip label={label.help} position="top">
      {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
      <Wrapper type={type}>
        <IconWrapper>
          {/* @ts-expect-error TS(2604) FIXME: JSX element type 'Icon' does not have any construc... Remove this comment to see the full error message */}
          <Icon size="small" />
        </IconWrapper>
      </Wrapper>
    </Tooltip>
  )
}

export default Label
